import React, { useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../../actions/auth.action';
// import avatar from '../../assets/img/avatar5.png';
import { useHistory } from 'react-router-dom';
import BusinessIcon from '@material-ui/icons/Business';
import SelectCompany from "../../components/SelectCompany";

import SignalCellularAltIcon from '@material-ui/icons/SignalCellularAlt';


import $ from 'jquery';
import ImageProfileCircle from "../../components/ImageProfileCircle";
import { Grid, Typography } from "@material-ui/core";
window.jQuery = $;
require('signalr');

const Navbar = ({ sidebarCollapsed, onToggleSidebar }) => {
  const history = useHistory();
  const proyects = useSelector(state => state.proyects);
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  
  let user = JSON.parse(localStorage.getItem("user-s10"));

  return (
    <nav className="navbar navbar-expand navbar-primary navbar-dark p-0" style={{
      background: '#3c8dbc',
      height: '50px',
      width: '100%'
    }}>
      
      <div className="d-flex justify-content-between align-items-center w-100 px-3">
        
        <div className="d-flex align-items-center">
          <button 
            className="btn btn-link text-white p-1 mr-2"
            onClick={onToggleSidebar}
            style={{ textDecoration: 'none' }}
          >
            <i className="fas fa-bars"></i>
          </button>

          <span className="text-white mx-2" style={{ fontSize: '12px' }}>
            Tablero S10 |
          </span>

          <Breadcrumb className="mb-0">
            <Breadcrumb.Item className="text-white" style={{ fontSize: '14px' }}>
              {proyects.titleProject} {proyects.titlePC && proyects.pc ? proyects.titlePC : ''}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="d-flex align-items-center">
          <SelectCompany setShow={setShow} show={show} changeCompany={true} />

              <button 
                className="btn btn-link text-white p-1 mx-2"
                style={{ textDecoration: 'none' }}
                  onClick={() => setShow(!show)}
              >
                  <h6
                    className="mb-1"
                    style={{color: 'white'}}
                  >
                    <BusinessIcon style={{ transform: "scale(1.3)", color: 'white' }} />
                  </h6>
                </button>
          
          <button 
            className="btn btn-link text-white p-1 mx-2"
            style={{ textDecoration: 'none' }}
          >
            <SignalCellularAltIcon 
              fontSizeLarge 
              style={{fontSize: "1.5rem", color:  auth.auth && !auth.loading ? 'white' : 'red'}}
            />
          </button>
          
          <div className="dropdown">
            <button 
              className="btn btn-link text-white dropdown-toggle d-flex align-items-center p-1"
              style={{ 
                textDecoration: 'none',
                border: 'none',
                background: 'transparent'
              }}
              data-toggle="dropdown"
            >


              {/* <img src={avatar} className="rounded-circle mr-2" width="25" alt="avatar" /> */}
              <div style={{marginRight: '10px'}}>
                {auth?.DataCompany?.RUC && 
                  <ImageProfileCircle
                    width="40px"
                    height="40px"
                    // ruc={userData?.RUCEmpresa as any}
                    ruc={auth?.DataCompany?.RUC}
                    userId={auth?.DataCompany?.Code}
                    userName={`${auth?.User?.FullName}`}
                  />
                }
              </div>


              <Grid
                  // sx={{ display: { xs: 'none', md: 'flex' } }}
                  style={{textAlign: 'left', marginRight: '10px'}}
                  container 
                  direction={"column"} 
                  // margin={"0 1rem 0 .5rem"}
              >
                  <Grid item>
                      <Typography
                          variant='h6'
                          style={{
                              color: "white",
                              fontFamily: "Roboto",
                              fontSize: ".875rem",
                              fontStyle: "normal",
                              fontWeight: "400",
                              lineHeight: "normal",
                              marginTop: ".3rem"
                          }}
                      >
                          {user && user.FullName}
                      </Typography>
                  </Grid>
                  <Grid item>
                      <Typography 
                          variant='h6'
                          style={{
                              color: "white",
                              fontFamily: "Roboto",
                              fontSize: ".75rem",
                              fontStyle: "normal",
                              fontWeight: "400",
                              // lineHeight: "normal",
                          }}
                      >
                         {auth?.DataCompany?.Roles?.Name || ''}
                      </Typography>
                  </Grid>
              </Grid>
            </button>
            
            <div className="dropdown-menu dropdown-menu-right" style={{paddingTop: '10px'}}>
              <Grid style={{padding: '5px 20px', fontSize: '12px', color: '#494949'}}>
                {user?.UserName}
              </Grid>
              <Grid style={{padding: '0 20px', fontSize: '12px', fontWeight: 500, color: '#494949'}}>
                {auth?.DataCompany?.Name}
              </Grid>
              <div className="dropdown-divider"></div>
              <div className="px-3 py-2">

                {/* <img src={avatar} alt="avatar" className="rounded-circle mb-2" width="60" /> */}
                
                <button 
                  className="dropdown-item text-danger"
                  style={{padding: '0 10px'}}
                  onClick={() => setShow(!show)}
                >
                  <h6
                    className="mb-1"
                    style={{color: '#494949'}}
                  >
                    <BusinessIcon style={{ transform: "scale(1.3)", marginRight: '10px' }} />
                    Cambio de corporación
                  </h6>
                </button>
              </div>
              <div className="dropdown-divider"></div>
              <button 
                className="dropdown-item text-danger"
                onClick={() => dispatch(logOut(history))}
              >
                <i className="fas fa-sign-out-alt mr-2"></i>
                Salir
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;